/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  standalone: false,
  selector: 'ideapa-select-field',
  template: `
    <ideapa-form-field-wrapper
      [label]="label"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
      [tooltip]="tooltip"
    >
      <ideapa-select
        [hasError]="shouldShowError"
        [formControl]="formControl"
        [bindValue]="bindValue"
        [clearable]="clearable"
        [bindLabel]="bindLabel"
        [multiple]="multiple"
        [placeholder]="placeholder"
        [searchable]="searchable"
        [items]="items"
        [canAdd]="canAdd"
        [canView]="canView"
        [readOnly]="readOnly"
        (changed)="onChange()"
        [setFocusOnInit]="setFocusOnInit"
      >
      </ideapa-select>
    </ideapa-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectFieldComponent extends BaseFormFieldComponent {
  @Input()
  placeholder = '';

  @Input()
  bindValue? = 'value';

  @Input()
  bindLabel = 'description';

  @Input()
  multiple = false;

  @Input()
  searchable = false;

  @Input()
  clearable = false;

  @Input()
  setFocusOnInit = false;

  @Input()
  items!: any[];

  @Input()
  canAdd? = false;

  @Input()
  canView? = false;

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  change = new EventEmitter();

  override ngOnInit(): void {
    super.ngOnInit();
    if (!this.items) {
      throw new Error('items unspecified for autocomplete');
    }
  }

  onChange() {
    this.change.emit();
  }
}
